import { useEffect } from 'react';

/**
 * Scrolls to the form errors container when the error or server errors change.
 *
 * NOTE: The form errors container must have an id of 'form-errors' to work properly.
 *
 * @param error - The error message to scroll to.
 * @param serverErrors - The server errors to scroll to.
 */
export function useScrollToFormErrors(
  error: string,
  serverErrors: string | null
) {
  useEffect(() => {
    if (error || serverErrors) {
      document
        .getElementById('form-errors')
        ?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [error, serverErrors]);
}
